// ** Auth Endpoints
export default {
	csrfCookieEndpoint: 'csrf-cookie',
	loginEndpoint: 'auth/login',
	registerEndpoint: '/auth/register',
	logoutEndpoint: 'auth/logout',
	forgotPasswordEndpoint: '/forgot-password',
	createPasswordEndpoint: '/create-password'
};
